import React, { useEffect, useState } from "react";
import { Form, Button, Modal, Row, Col } from "antd";
import "../../../pagination.css";
import AddressInputForm from "../../addressInputForm";
import CustomButton from "../../../components/ButtonCustom";
import { CustomInput } from "../../../components/CustomInput";
import "./style.css";
import { formItemLayout } from "../../../constants";

const СollectiveAppealUserForm = (props) => {
  const {
    isDisabled,
    visible,
    handleCancel,
    i18n,
    isRu,
    changedValue,
    addUser,
    setChangedUser,
    updateUser,
    resetRepetition
  } = props;
  const [form] = Form.useForm();
  const [address, setAddress] = useState(null);
  const minStringWidth = 2;
  const maxStringWidth = 200;
  const [lastId, setLastId] = useState(0)

  useEffect(() => {
    if (changedValue) {
      const address = {
        reAddress: changedValue.Address,
        reAdministrativeTerritory: changedValue.AdministrativeTerritory,
        reDistrict: changedValue.District,
        reRegion: changedValue.Region,
        isOutsideRB: changedValue.isOutsideRB,
        reCountry: changedValue.ReCountry,
        house: changedValue.House,
        office: changedValue.Office,
        postIndex: changedValue.postIndex,
        notice: changedValue.Notice,
      };
      setAddress(address);
      form.setFieldsValue({
        ApplicantLastName: changedValue.ApplicantLastName,
        ApplicantFirstName: changedValue.ApplicantFirstName,
        ApplicantMiddleName: changedValue.ApplicantMiddleName,
        ApplicantEmail: changedValue.ApplicantEmail,
      });
      setLastId(changedValue.LastId)
    }
  }, [changedValue]);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setAddress(null);
    }
  }, [visible]);

  const onClick = () => {
    form
      .validateFields()
      .then((values) => {
        if (!changedValue) {
          addUser(values);
          handleCancel();
        } else {
          updateUser({LastId:lastId, ...values}, changedValue.id);
          setChangedUser(null);
          if(changedValue.id == 0 && resetRepetition != null)
          resetRepetition(false)
          handleCancel();
        }
        form.resetFields();
      })
      .catch((errInfo) => {});
  };

  return (
    <Modal
      destroyOnClose
      footer={[]}
      maskClosable={false}
      title={i18n.addExecutorResult[isRu]}
      visible={visible}
      width={1000}
      onCancel={() => {
        form.resetFields();
        handleCancel();
        setAddress(null);
      }}
    >
      <Form
        form={form}
        labelAlign="left"
        {...formItemLayout}
        name="addUserCollectiveForm"
      >
        <Row className="container-collective-form">
          <Col className="header-container-reg-form">
            <Form.Item
              label={<span>{i18n.lastName[isRu]}</span>}
              name="ApplicantLastName"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  min: minStringWidth,
                  max: maxStringWidth,
                  message: i18n.lastNameRequiredWithWidthLimit[isRu].replace("{0}",`${minStringWidth} - ${maxStringWidth}`),
                },
              ]}
            >
              <CustomInput
              disabled = {isDisabled}
              placeholder={i18n.lastName[isRu]} />
            </Form.Item>
            <Form.Item
              label={i18n.firstName[isRu]}
              name="ApplicantFirstName"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  min: minStringWidth,
                  max: maxStringWidth,
                  message: i18n.lastNameRequiredWithWidthLimit[isRu].replace("{0}",`${minStringWidth} - ${maxStringWidth}`),
                },
              ]}
            >
              <CustomInput
              disabled = {isDisabled}
              placeholder={i18n.firstName[isRu]} />
            </Form.Item>
            <Form.Item label={i18n.middleName[isRu]} name="ApplicantMiddleName">
              <CustomInput
              disabled = {isDisabled}
              placeholder={i18n.middleName[isRu]} />
            </Form.Item>
            <Form.Item
              label={i18n.ApplicantEmail[isRu]}
              name="ApplicantEmail"
              rules={[
                {
                  type: "email",
                  message: i18n.emailRequired[isRu],
                },
              ]}
            >
              <CustomInput
              disabled = {isDisabled}
              placeholder={i18n.ApplicantEmail[isRu]} />
            </Form.Item>

            <AddressInputForm
              address={address}
              disabled = {isDisabled}
              form={form}
              isLegalEntity={!address?.isOutsideRB}
              placeholder={i18n.address[isRu]}
              noAddressOption={true}
            />
            <Form.Item>
              <CustomButton disabled = {isDisabled} type="orange" onClick={onClick}>
                {changedValue ? i18n.update[isRu] : i18n.addExecutorResult[isRu]}
              </CustomButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default СollectiveAppealUserForm;
